import produce from 'immer'
import * as E from 'constants/Errors'
import * as C from './constants'

const authReducer = (state = C.INITIAL_STATE, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case C.HYDRATE_UNITE_SUCCESS:
        draft.token = action.payload.token
        draft.tokenType = action.payload.tokenType || 'JWT'
        draft.accountId = action.payload.accountId
        draft.userId = action.payload.userId
        break
      case C.HYDRATE_UNITE_FAILURE:
        draft.loading = false
        draft.error = E.STORAGE_TOKEN_ERROR
        break
      case C.TOKEN_UPDATE:
        draft.token = action.payload
        break
      case C.USER_FETCH_PENDING:
        draft.loading = true
        break
      case C.USER_FETCH_FULFILLED:
        draft.loading = false
        draft.userId = action.payload.user.id
        break
      case C.USER_FETCH_REJECTED:
      case C.ERROR:
        draft.loading = false
        draft.error = draft.error || action.payload
        break
      default:
        break
    }
  })

export default authReducer
